<!--
 * @Author: 汪俊洪
 * @Date: 2025-06-04 14:33:54
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-04 16:56:41
 * @Description:
-->
<template>
  <div class="wrap">
    <div class="content">
      <h2 class="title">常见问题解答</h2>
      <div class="list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="`item item${index + 1}`"
        >
          <h3 class="item-title">{{ item.title }}</h3>
          <div class="item-des">
            {{ item.des }}
          </div>
        </div>
      </div>
      <div class="bottom-tip">
        <a href="javascript:" @click="setVisible">立即加入</a
        >中控技术工程生态资源库，共享工业数智化红利！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        {
          title: 'Q：入驻是否需要缴纳费用？',
          des: 'A：目前平台入驻及基础功能免费，后续增值服务将另行通知。'
        },
        {
          title: 'Q：能力标签如何申请？',
          des: 'A：登录平台后，在 “企业中心 - 能力认证” 模块提交相关证书、案例等资料，经审核通过后生效。'
        },
        {
          title: 'Q：如何查看我的任务进度？',
          des: 'A：在 “报工”“结算” 等栏目中，可实时查看接单详情、报工记录及结算状态。'
        }
      ]
    }
  },
  methods: {
    setVisible () {
      this.$emit('setVisible')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 40px 0 75px;
  background: #fff;
  .content {
    width: 1200px;
    margin: 0 auto;
  }
  .title {
    font-size: 40px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    margin: 0 0 0;
    line-height: 49px;
  }
}
.list {
  display: flex;
  justify-content: space-between;
  padding: 80px 0;
  .item {
    display: flex;
    flex-direction: column;
    width: 374px;
    border-radius: 8px;
    padding: 40px 20px;
  }
  .item-title {
    margin: 0 0 40px;
    font-size: 24px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
  }
  .item-des {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.4);
  }
}
.bottom-tip {
  font-size: 24px;
  color: #3d3d3d;
  text-align: center;
  a {
    color: #2a54d1;
  }
}
</style>
